<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OuW930/tc-custom/9781452125053.jpg?1721404776851" alt="This image is the cover for the book Braises and Stews"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Braises and Stews
      </h1>
      <p class="bookDescription body article font2">
        <b>Enjoy the satisfying flavors of slow-cooked comfort food with this easy-to-use volume brimming with delicious, traditional recipes.</b><br/><br/>Remember those tantalizing smells coming from Grandma’s kitchen as she made her treasured, slow-cooked meals? Braises and Stews brings modern convenience and style to good old-fashioned comfort food. <br/><br/>Organized by main ingredient, this handy cookbook dishes up the secrets for making such savory one-pot meals as Classic Pot Roast or Pub Short Ribs. Lighter fare like Coq au Vin prepared with white wine or a Roman-inspired Spring Stew of Favas, Artichokes, and Fresh Peas will appeal to those with smaller appetites. Why stew over dinner when there are so many tasty options to throw in the pot?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tori Ritchie, Ben Fink
      </h2>
      
      <p class="authorDescription body article">Tori Ritchie is a San Francisco-based food writer and host of CBS's Five-Minute Cooking School.New York photographer Ben Fink's work has appeared in Saveur, Food & Wine, and Bon AppÃ©tit magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62fc8d21